import { colors, makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  container: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    alignItems: "center",
  },
  invoiceTitle: {
    fontWeight: "600",
    fontSize: "18px",
  },
  label: {
    fontWeight: "500",
    fontSize: "16px",
    color: theme.palette.text.secondary,
  },
  value: {
    fontWeight: "600",
    fontSize: "16px",
    color: theme.palette.text.brand_tertiary,
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  remainingAmmount: {
    fontWeight: "500",
    fontSize: "16px",
    color: theme.palette.text.tertiary,
  },
  iconContainer: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  bedroomsDetails: {
    display: "flex",
    gap: "4px",
    "& path": {
      fill: theme.palette.foreground.quinary,
    },
  },
  numberOfBedrooms: { color: theme.palette.text.tertiary },
  copyToClipboard: {
    color: theme.palette.text.tertiary,
    "& path": {
      fill: theme.palette.text.tertiary,
    },
  },
}));
